<script setup lang="ts">
  import SectionBalance from './section-balance.vue'
  import SectionMenus from './section-menus.vue'

  const version = __APP_VERSION__
</script>

<template>
  <div>
    <section-balance class="mb-8" />

    <section-menus />

    <div class="text-center text-xs mt-16">
      v{{ version }}
    </div>
  </div>
</template>
